// Import necessary components
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({
  data,
  indexAxis,
  hideBorder,
  value,
  showLabel = false,
  gridShow = true,
  yGridShow = false,
  height = "30vh",
}) => {
  let maxValue = 0;
  if (value?.length > 0) {
    maxValue = Math.max(...value);
  }

  if (maxValue < 10) {
    maxValue = maxValue + 9;
  }

  const options = {
    indexAxis: indexAxis,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        caretSize: 8,
        backgroundColor: "#1E242C",
        padding: {
          x: 20,
          y: 15,
        },
      },
      datalabels: {
        display: showLabel,
        anchor: "end",
        align: "end",
        formatter: function (value, context) {
          return value;
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: gridShow,
          color: "#ebebeb",
        },
        border: {
          display: hideBorder,
        },
        ticks: {
          stepSize: 100,
        },
      },
      y: {
        grid: {
          display: yGridShow,
          color: "#ebebeb",
        },
        border: {
          display: hideBorder,
          dash: [5, 5],
        },
        min: 0,
        ticks: {
          stepSize: convertOddToNearestEven(Math.ceil(maxValue / 4)),
        },
      },
    },
  };

  function convertOddToNearestEven(oddNumber) {
    if (oddNumber % 2 !== 0) {
      return oddNumber + 1;
    } else {
      return oddNumber;
    }
  }

  return (
    <div className={`p-[10px] relative w-full`} style={{ height: height }}>
      <Bar
        fill="red"
        data={data}
        options={options}
        plugins={[ChartDataLabels]}
      />
    </div>
  );
};

export default BarChart;
